<div class="layers-container">
  <gb-presenter-tools-elevation
    (bringToFront)="onBringToFront()"
    (bringForward)="onBringForward()"
    (sendBackward)="onSendBackward()"
    (sendToBack)="onSendToBack()"
  ></gb-presenter-tools-elevation>
  @if (layers; as layersList) {
    <div class="layers-list">
      @for (layer of notificationLayers; track layer.uuid) {
        <div
          class="layer-row layer-row--pinned layer-row--notification"
          [class.selected]="selectedWidget?.uuid === layer.uuid"
          (click)="onSelectLayer(layer)"
        >
          <div class="layer-main">
            <div class="layer-name">
              @if (layer.isLabelKey) {
                {{ layer.label | translate }}
              } @else {
                {{ layer.label }}
              }
            </div>
          </div>
        </div>
      }

      <div cdkDropList class="layers-drop" (cdkDropListDropped)="onDrop($event)">
        @for (layer of draggableLayers; track layer.uuid) {
          <div
            class="layer-row"
            [class.selected]="selectedWidget?.uuid === layer.uuid"
            cdkDrag
            (click)="onSelectLayer(layer)"
            [cdkDragData]="layer"
          >
            <div class="drag-handle">
              <mat-icon>drag_indicator</mat-icon>
            </div>

            <div class="layer-main">
              <div class="layer-name">
                @if (layer.isLabelKey) {
                  {{ layer.label | translate }}
                } @else {
                  {{ layer.label }}
                }
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="layer-row layer-row--pinned layer-row--background"
        [class.selected]="!selectedWidget"
        (click)="onSelectBackground()"
        [style.backgroundColor]="backgroundImage ? null : resolvedBackgroundColor"
        [style.backgroundImage]="backgroundImage ? 'url(' + backgroundImage + ')' : null"
        [style.backgroundSize]="backgroundImage ? 'cover' : null"
        [style.backgroundPosition]="backgroundImage ? 'center' : null"
        [style.backgroundRepeat]="backgroundImage ? 'no-repeat' : null"
      >
        <div class="layer-main">
          <div class="layer-name" [style.color]="backgroundLabelColor">{{ 'PRESENTER.BACKGROUND' | translate }}</div>
        </div>
      </div>
    </div>
  }
</div>
